import { render, staticRenderFns } from "./CompanyNotificationsPage.vue?vue&type=template&id=5d56771e&scoped=true"
import script from "./CompanyNotificationsPage.vue?vue&type=script&lang=js"
export * from "./CompanyNotificationsPage.vue?vue&type=script&lang=js"
import style0 from "./CompanyNotificationsPage.vue?vue&type=style&index=0&id=5d56771e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d56771e",
  null
  
)

export default component.exports